import type { ComingSoonConfig } from '@/lib/coming-soon';
import { apiPut, apiRequest } from './api-client';

export async function getComingSoonConfig(): Promise<ComingSoonConfig | null> {
  try {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer =
      controller != null ? window.setTimeout(() => controller.abort(), 2500) : undefined;
    try {
      const res = await apiRequest<{ data: ComingSoonConfig }>('/coming-soon', {
        method: 'GET',
        auth: false,
        cache: 'no-store',
        signal: controller?.signal,
      });
      return res.data ?? null;
    } finally {
      if (timer != null) window.clearTimeout(timer);
    }
  } catch {
    return null;
  }
}

export async function updateComingSoonConfig(config: ComingSoonConfig): Promise<ComingSoonConfig> {
  const res = await apiPut<{ data: ComingSoonConfig }>('/admin/coming-soon', config, true);
  return res.data;
}
